var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isLoaded
        ? _vm._t("default")
        : _c("section", { staticClass: "category__banner" }, [
            _c(
              "span",
              {
                class: {
                  "category__back-btn--hidden":
                    typeof _vm.currentCategory.parent === "undefined",
                },
              },
              [
                typeof _vm.currentCategory.parent !== "undefined"
                  ? _c("a", {
                      staticClass: "category__back-btn",
                      attrs: {
                        href: _vm.getCategoryUrl(
                          _vm.currentCategory.parent.url
                        ),
                        title:
                          _vm.currentCategory.parent.details[0].metaTitle ||
                          _vm.currentCategory.parent.details[0].name,
                      },
                    })
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "category__pretitle" }, [
                _vm.currentCategoryRoot !== ""
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.getCategoryUrl(_vm.currentCategoryRoot.url),
                          title: _vm.currentCategoryRoot.name,
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.currentCategoryRoot.name) +
                            "\n                "
                        ),
                      ]
                    )
                  : _c("div", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.currentCategoryRoot) +
                          "\n                "
                      ),
                    ]),
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "category__title" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.currentCategory.details[0].name) +
                    "\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.currentCategoryChildes.length > 0
              ? _c("div", { staticClass: "category__banner-sub-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "category__banner-sub-inner" },
                    _vm._l(_vm.currentCategoryChildes, function (category) {
                      return _c(
                        "a",
                        {
                          staticClass: "category__banner-item",
                          class: {
                            "category__banner-item--active": category.active,
                          },
                          attrs: {
                            href: _vm.getCategoryUrl(category.url),
                            title: category.metaTitle || category.name,
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(category.name) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }